<template>
	<div :class="['card-layout', highlights && 'is-highlights']">
		<div class="card-layout__content">
			<slot name="content" />
		</div>

		<div class="card-layout__actions">
			<slot name="actions" />
		</div>

		<div class="card-layout__footer" v-if="$slots.footer">
			<slot name="footer" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'CardLayoutComponent',
	props: {
		highlights: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss">
/**
    * Card Layout Card
    * Can use SCSS variables = TRUE
 */

@import '@/scss/5-objects/_cards.scss';
@import '@/scss/5-objects/_form.scss';

.card-layout {
	@include card;
	display: grid;
	grid-template-columns: 1fr auto;
	column-gap: $gutter-xxl;
	overflow: hidden;

	&__content {
		@include mq($from: md) {
			flex: 2 1;
		}
		min-width: 0;
	}

	&__actions {
		@include mq($until: md) {
			margin-top: $gutter-md;
		}
		@include mq($from: md) {
			align-self: center;
		}
	}

	&__footer {
		grid-column: 1/3;
	}

	/* Card has matches */
	&.is-highlights {
		@include card('focus');
	}
}
</style>
